import * as types from '@/store/mutation-types';

export const setLanguage = ({ commit }, language) => {
    commit(types.SET_LANGUAGE, language);
};

export const setNetworkStatus = ({ commit }, status) => {
    commit(types.SET_NETWORK_STATUS, status);
};

export const setProtocol = ({ commit }, protocol) => {
    commit(types.SET_PROTOCOL, protocol);
};

export const setRoute = ({ commit }, route) => {
    commit(types.SET_ROUTE, route);
};

export const setStartedWidget = ({ commit }, widget) => {
    commit(types.SET_STARTED_WIDGET, widget);
};

export const setInternalStatus = ({ commit }, status) => {
    commit(types.SET_INTERNAL_STATUS, status);
};

export const setIframeStatus = ({ commit }) => {
    commit(types.SET_IFRAME_STATUS, window.self !== window.top);
};

export const setCookiesStatus = ({ commit }, status) => {
    commit(types.IS_COOKIES_ENABLED, status);
}

export const setTrackingStatus = ({ commit }, data) => {
    commit(types.SET_TRACKING_STATUS, data);
}

export const checkLocalstorage = ({ commit }) => {
    let result = false;
    try {
        result = typeof localStorage !== undefined;
    }
    catch(error) {
        console.log(error);
    }
    commit(types.IS_LOCALSTORAGE_AVAILABLE, result);
};

export const toggleCookieDisclaimer = ({ commit }) => {
    commit(types.TOGGLE_COOKIE_DISCLAIMER);
};

export const checkGPDRConsent = ({ commit }) => {
    commit(types.CHECK_GPDR_CONSENT);
};

export const setIsLoading = ({ commit }, status) => {
    commit(types.SET_IS_LOADING, status);
};

export const setLogo = ({commit}, imageData) => {
    commit(types.SET_LOGO, imageData);
}

export const setProgramInfo = ({commit}, data) => {
    commit(types.SET_PROGRAM_INFO, data);
}

export const setLoadingBackground = ({commit}, img) => {
    commit(types.SET_LOADING_BACKGROUND, img);
}

export const setSnackbar = ({commit}, data) => {
    commit(types.SET_SNACKBAR, data);
}

export const setDisableCloseSidebarStatus = ({commit}, status) => {
    commit(types.SET_DISABLE_CLOSE_SIDEBAR, status);
}

export const setResolution = ({commit}, resolution) => {
    commit(types.SET_RESOLUTION, resolution);
}

export const setIsFrontless = ({commit}, status) => {
    commit(types.SET_IS_FRONTLESS, status);
}

export const toggleNavbar = ({commit}) => {
    commit(types.TOGGLE_NAVBAR);
}


// WEBPACK FOOTER //
// ./src/store/actions.js